{
  "title": "Оповещения",
  "orgIntro": "Оповещения всех проектов, которые вы видите, и общие правила организации. Тишина и каналы у каждого проекта свои: они в «Этот проект».",
  "projectIntro": "Оповещения этого проекта: что происходит сейчас, история, правила, тишина на время работ и куда отправлять сообщения.",
  "tabsLabel": "Разделы оповещений",
  "tabs": {
    "active": "Активные",
    "history": "История",
    "rules": "Правила",
    "silences": "Тишина",
    "channels": "Каналы"
  },
  "scope": {
    "label": "Охват оповещений",
    "project": "Этот проект",
    "organization": "Вся организация"
  },
  "mine": "Настройки уведомлений",
  "wholeProject": "Весь проект",
  "severity": { "warn": "Внимание", "critical": "Критично" },
  "minSeverity": { "warn": "Предупреждения и критичные", "critical": "Только критичные" },
  "status": {
    "firing": "Активно",
    "resolved": "Решено",
    "oneOff": "Событие",
    "mutedUntil": "Заглушено до {{time}}",
    "maintenance": "Обслуживание",
    "muted": "Заглушено"
  },
  "kinds": {
    "agent_down": "Агент не отвечает",
    "server_off": "Сервер не работает",
    "cpu_high": "Высокая загрузка процессора",
    "memory_high": "Мало памяти",
    "disk_high": "Диск заполнен",
    "load_high": "Высокая нагрузка",
    "disk_forecast": "Диск скоро заполнится",
    "container_down": "Контейнер не работает",
    "service_down": "Сервис упал",
    "security_updates": "Обновления безопасности",
    "ssl_expiring": "Сертификат истекает",
    "operation_failed": "Операция не удалась",
    "budget_threshold": "Порог бюджета"
  },
  "text": {
    "agent_down": "Агент Автопилота не отвечает",
    "server_off": "Сервер не работает",
    "cpu_high": "Процессор {{value}}\u00a0% (порог {{threshold}}\u00a0%)",
    "memory_high": "Память {{value}}\u00a0% (порог {{threshold}}\u00a0%)",
    "disk_high": "Диск {{subject}}: {{value}}\u00a0% (порог {{threshold}}\u00a0%)",
    "load_high": "Нагрузка {{value}} на ядро (порог {{threshold}})",
    "disk_forecast": "Диск {{subject}} заполнится примерно через {{value}}\u00a0ч",
    "container_down": "Контейнер {{subject}} не работает",
    "service_down": "Сервис {{subject}} упал",
    "security_updates": "Ждут обновления безопасности: {{value}}",
    "ssl_expiring": "Сертификат {{subject}} истекает через {{value}}\u00a0дн.",
    "sslExpired": "Сертификат {{subject}} истёк",
    "operation_failed": "Операция завершилась ошибкой: {{subject}}",
    "budget_threshold": "Расходы проекта достигли {{subject}} бюджета"
  },
  "condition": {
    "percent": "выше {{threshold}}\u00a0%",
    "per_core": "выше {{threshold}} на ядро",
    "hours": "заполнится за {{threshold}}\u00a0ч",
    "days": "за {{threshold}}\u00a0дн. до конца",
    "count": "от {{threshold}}",
    "for": "дольше {{minutes}}\u00a0мин",
    "atOnce": "сразу",
    "event": "при каждом событии"
  },
  "source": {
    "default": "По умолчанию",
    "organization": "Организация",
    "project": "Проект",
    "server": "Сервер",
    "here": "Задано здесь"
  },
  "columns": {
    "what": "Что случилось",
    "where": "Где",
    "started": "Началось",
    "state": "Состояние",
    "rule": "Правило",
    "condition": "Условие",
    "severity": "Важность",
    "source": "Откуда"
  },
  "actions": {
    "mute": "Заглушить на 1\u00a0ч",
    "muteServer": "Заглушить сервер на 1\u00a0ч",
    "unmute": "Снять",
    "edit": "Изменить",
    "loadMore": "Показать ещё",
    "markRead": "Отметить прочитанными"
  },
  "toast": {
    "muted": "Заглушено до {{time}}",
    "muteFailed": "Не удалось заглушить",
    "new": "Новое оповещение",
    "several": "Новых оповещений: {{n}}"
  },
  "empty": {
    "activeTitle": "Всё спокойно",
    "active": "Сейчас ничего не горит. Когда сработает правило, оповещение появится здесь и придёт тем, кто подписан.",
    "historyTitle": "Оповещений ещё не было",
    "history": "Здесь будут все оповещения: когда начались, когда закончились и кому ушли. Хранятся 90 дней."
  },
  "rule": {
    "title": "Правило: {{name}}",
    "about": {
      "agent_down": "Агент Автопилота на сервере перестал присылать данные.",
      "server_off": "Провайдер сообщает, что сервер выключен или не отвечает. Серверы, выключенные через панель, не считаются.",
      "cpu_high": "Загрузка процессора держится выше порога.",
      "memory_high": "Занятая память держится выше порога.",
      "disk_high": "Корневая файловая система заполнена выше порога.",
      "load_high": "Средняя нагрузка за минуту в расчёте на одно ядро выше порога.",
      "disk_forecast": "Если диск будет заполняться так же, как за последние сутки, он заполнится раньше, чем через указанное число часов.",
      "container_down": "Контейнер Docker остановился с ошибкой, перезапускается или нездоров.",
      "service_down": "Сервис systemd упал (failed).",
      "security_updates": "На сервере ждут обновления безопасности. Панель их не ставит — команда на вкладке «Автопилот».",
      "ssl_expiring": "Сертификат проекта или найденный Автопилотом на сервере истекает раньше, чем через указанное число дней.",
      "operation_failed": "Операция панели (создание, пересборка, изменение) завершилась ошибкой.",
      "budget_threshold": "Расходы проекта достигли порога его бюджета."
    },
    "reset": "Вернуть как выше",
    "save": "Сохранить",
    "enabled": "Правило включено",
    "threshold": {
      "percent": "Порог, %",
      "per_core": "Порог, нагрузка на ядро",
      "hours": "Заполнится быстрее, чем за, часов",
      "days": "Истекает раньше, чем через, дней",
      "count": "Сколько обновлений, не меньше"
    },
    "duration": "Сколько минут подряд",
    "durationHint": "0 — оповещать сразу.",
    "severity": "Важность",
    "above": "Уровнем выше ({{source}}): {{condition}}",
    "off": "Выключено",
    "cloudEvent": "Событие облака",
    "editLabel": "Изменить правило «{{name}}»"
  },
  "rules": {
    "orgTitle": "Правила по умолчанию",
    "orgIntro": "Действуют во всех проектах организации, пока проект или сервер не задаст своё.",
    "orgReadOnly": "Действуют во всех проектах, пока проект или сервер не задаст своё. Менять их могут администраторы организации; свои значения проекта — в «Этот проект → Правила».",
    "sharedRule": "Общее правило организации",
    "projectTitle": "Правила проекта",
    "projectIntro": "Свои значения проекта поверх правил организации. Для одного сервера их можно уточнить на его вкладке «Оповещения»."
  },
  "channels": {
    "title": "Боты Telegram",
    "intro": "Через этих ботов приходят оповещения. Основной бот работает для всех проектов, пока проект не выберет другого.",
    "addBot": "Добавить бота",
    "emptyTitle": "Ботов ещё нет",
    "empty": "Создайте бота у @BotFather в Telegram и добавьте его здесь по токену. Потом каждый привяжет к нему свой Telegram в «Настройки уведомлений» (меню профиля).",
    "default": "Основной",
    "failing": "Не работает",
    "failingHint": "Telegram не принимает токен этого бота. Создайте новый токен у @BotFather и добавьте бота заново.",
    "token": "Токен",
    "linkedLabel": "Привязано",
    "linked": "людей: {{people}}, чатов: {{groups}}",
    "usedBy": "Проекты",
    "usedByDefault": "все, кроме выбравших другого бота",
    "usedByNone": "никто не выбрал",
    "test": "Проверить",
    "tested": "Проверочное сообщение отправлено: {{chat}}",
    "testFailed": "Проверка не прошла",
    "makeDefault": "Сделать основным",
    "remove": "Удалить",
    "removeTitle": "Удалить бота @{{username}}?",
    "removeLinks": "Все привязанные к нему чаты людей и групп будут отвязаны.",
    "removeDefault": "Основным станет следующий бот, если он есть.",
    "removeProjects": "Проекты, выбравшие этого бота, перейдут на основного.",
    "removeToken": "Токен бота будет удалён из панели; сам бот в Telegram останется.",
    "add": {
      "title": "Добавить бота Telegram",
      "description": "Оповещения будут приходить от имени этого бота.",
      "step1": "В Telegram откройте @BotFather и отправьте /newbot.",
      "step2": "Придумайте имя и адрес бота — BotFather пришлёт токен.",
      "step3": "Вставьте токен сюда.",
      "token": "Токен бота",
      "never": "Мы проверим токен в Telegram и сохраним зашифрованным. Больше он нигде не показывается.",
      "submit": "Добавить",
      "done": "Бот @{{username}} добавлен"
    }
  },
  "link": {
    "personTitle": "Привязать Telegram",
    "personDone": "Готово: привязан {{chat}}",
    "personStep1": "Откройте ссылку на телефоне или компьютере, где у вас Telegram, и нажмите «Запустить».",
    "personStep2": "Бот ответит, что аккаунт привязан, — эта страница увидит это сама.",
    "groupTitle": "Привязать групповой чат",
    "groupStep1": "Откройте ссылку и выберите групповой чат, куда добавить бота.",
    "groupStep2": "Telegram добавит бота в чат и передаст ему одноразовый код.",
    "groupStep3": "Бот напишет в чате, что оповещения проекта будут приходить туда.",
    "open": "Открыть @{{bot}} в Telegram",
    "byHand": "Если ссылка не открылась, отправьте боту @{{bot}} команду:",
    "commandLabel": "Команда привязки",
    "expires": "Ссылка одноразовая и действует до {{time}}.",
    "done": "Готово"
  },
  "silences": {
    "mutesTitle": "Заглушено сейчас",
    "mutesIntro": "Пока оповещение заглушено, о нём никому не сообщают. История всё равно ведётся.",
    "mutesEmpty": "Ничего не заглушено.",
    "allAlerts": "Все оповещения",
    "until": "До",
    "by": "Кто",
    "windowsTitle": "Окна обслуживания",
    "windowsIntro": "Плановые работы: оповещения проекта или одного сервера в это время никому не приходят.",
    "windowsEmpty": "Окон обслуживания не запланировано.",
    "addWindow": "Запланировать окно",
    "when": "Когда",
    "reason": "Причина",
    "deleteWindow": "Удалить окно обслуживания",
    "window": {
      "title": "Окно обслуживания",
      "description": "В это время оповещения не отправляются. Время — ваше местное.",
      "server": "Сервер",
      "starts": "Начало",
      "ends": "Конец",
      "reason": "Причина (необязательно)",
      "create": "Запланировать"
    }
  },
  "project": {
    "botTitle": "Бот проекта",
    "botIntro": "От имени какого бота приходят оповещения этого проекта.",
    "noBots": "В организации ещё нет ботов Telegram.",
    "addBot": "Добавить бота",
    "bot": "Бот",
    "useDefault": "Основной организации (@{{username}})",
    "sentBy": "Оповещения проекта приходят от @{{username}}.",
    "groupsTitle": "Групповые чаты",
    "groupsIntro": "Оповещения проекта приходят и в эти чаты — например, в чат дежурных.",
    "groupMin": "Что присылать",
    "linkGroup": "Привязать групповой чат",
    "groupsEmpty": "Групповых чатов нет. Привяжите чат команды — бот будет писать туда.",
    "groupsEmptyGuest": "Групповых чатов нет.",
    "chat": "Чат",
    "linked": "Привязан",
    "unlinkGroup": "Отвязать"
  },
  "server": {
    "noAutopilot": "Автопилот на этом сервере выключен: работают только правило «Сервер не работает» и события облака. Включите Автопилот на одноимённой вкладке, чтобы следить за памятью, дисками, сервисами и контейнерами.",
    "activeTitle": "Сейчас",
    "activeIntro": "Что горит на этом сервере.",
    "activeEmpty": "На этом сервере сейчас всё в порядке.",
    "historyTitle": "История сервера",
    "rulesTitle": "Правила сервера",
    "rulesIntro": "Свои значения для этого сервера поверх правил проекта."
  },
  "profile": {
    "title": "Настройки уведомлений",
    "intro": "Куда и о чём сообщать именно вам: привязка Telegram, проекты и серверы, важность, тихие часы.",
    "telegramTitle": "Telegram",
    "telegramIntro": "Привяжите свой Telegram к боту организации — оповещения будут приходить вам в личные сообщения.",
    "noBots": "В организации ещё нет бота Telegram. Попросите администратора добавить его в «API и интеграции → Мессенджеры».",
    "linkedAs": "Привязан: {{chat}}",
    "notLinked": "Не привязан",
    "link": "Привязать Telegram",
    "unlink": "Отвязать",
    "whatTitle": "Что присылать",
    "whatIntro": "По умолчанию — всё, что вы видите в панели, начиная с предупреждений.",
    "projects": "Проекты",
    "allProjects": "Все проекты, к которым у меня есть доступ",
    "chosenProjects": "Только выбранные проекты",
    "serversOf": "Серверы проекта",
    "allServers": "Все серверы",
    "chosenServers": "Только выбранные серверы",
    "minSeverity": "Важность",
    "quietTitle": "Тихие часы",
    "quietOn": "Не присылать в Telegram в тихие часы",
    "quietStart": "С",
    "quietEnd": "До",
    "timeZone": "Часовой пояс",
    "allowCritical": "Критичные присылать всё равно",
    "whereTitle": "Куда",
    "panel": "В панель",
    "telegram": "В Telegram",
    "language": "Язык сообщений",
    "save": "Сохранить",
    "saved": "Настройки уведомлений сохранены",
    "inboxTitle": "Последние уведомления",
    "inboxIntro": "Оповещения, которые пришли вам в панель.",
    "inboxEmpty": "Уведомлений пока нет.",
    "unread": "Не прочитано"
  }
}
